export default __webpack_public_path__ + "static/media/cirec3.e971978a.png";